// desktop
export { default as NBADesk } from './desktop/NBADesk.png';
export { default as MLBDesk } from './desktop/MLBDesk.png';
export { default as NFLDesk } from './desktop/NFLDesk.png';
export { default as NHLDesk } from './desktop/NHLDesk.png';
export { default as PGADesk } from './desktop/PGADesk.png';
export { default as MLSDesk } from './desktop/MLSDesk.webp';
export { default as NascarDesk } from './desktop/NascarDesk.webp';
export { default as Formula1Desk } from './desktop/Formula1Desk.webp';
export { default as UFCDesk } from './desktop/UFCDesk.webp';
export { default as ArtistNameDesk } from './desktop/ArtistNameDesk.png';
export { default as CityNameDesk } from './desktop/CityNameDesk.png';
export { default as EventDesk } from './desktop/eventDesk.png';
// mobile
export { default as NBAMobile } from './mobile/NBAMobile.png';
export { default as MLBMobile } from './mobile/MLBMobile.png';
export { default as NFLMobile } from './mobile/NFLMobile.png';
export { default as NHLMobile } from './mobile/NHLMobile.png';
export { default as PGAMobile } from './mobile/PGAMobile.png';
export { default as ArtistNameMobile } from './mobile/ArtistNameMobile.png';
export { default as CityNameMobile } from './mobile/CityNameMobile.png';
export { default as EventMobile } from './mobile/eventMobile.png';
